import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { SubHeader, Input } from '../../components/'
import { regEx } from '../../../../resources/Utils'

const Detail = ({ onChange, ...props }) => {
  return (
    <>
      <SubHeader text="Contact Detail" />
      <Row style={{ padding: "0.5rem 0" }}>
        <Col>
          <Input text="Contact's First Name" onChange={onChange} placeholder="first name" name="firstName" value={props["firstName"]} required disabled={props.disabled} maxLength={128} pattern={regEx.ALPHANUMERIC} title="First name must be alphanumeric"/>
        </Col>
        <Col>
          <Input text="Contact's Last Name" onChange={onChange} placeholder="last name" name="lastName" value={props["lastName"]} required disabled={props.disabled} maxLength={128} pattern={regEx.ALPHANUMERIC} title="Last name must be alphanumeric"/>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input text="Contact's Email Address" onChange={onChange} name="email" value={props["email"]} required disabled={props.disabled} pattern={regEx.EMAIL} title="Email address is invalid format."/>
        </Col>
        <Col>
          <Input text="Contact's Phone Number" onChange={onChange} placeholder="phone number" name="phoneNo" value={props["phoneNo"]} format="NUMERIC" maxLength={10} disabled={props.disabled}/>
        </Col>
      </Row>
    </>
  )
}

export default Detail
